export const QA_NAME_DOC_FLOW_MAPPING_RECIPIENT_MODAL =
  'docFlowMappingRecipientModal'

export const QA_NAME_DOC_FLOW_MAPPING_RECIPIENT_MODAL_SUBMIT_BTN =
  'docFlowMappingRecipientSubmit'

export const QA_NAME_DOC_FLOW_MAPPING_RECIPIENT_MODAL_SKIP_BTN =
  'docFlowMappingRecipientSkip'

export const QA_NAME_DOC_FLOW_MAPPING_RECIPIENT_MODAL_ADD_SUGGESTION_BTN =
  'docFlowMappingRecipientAddSuggestion'

export const DOC_FLOW_MAPPING_RECIPIENT_MODAL_FIRST_POSITION = 1

export const DOC_FLOW_MAPPING_RECIPIENT_MODAL_PAGE_SIZE = 1
